import { render, staticRenderFns } from "./Anomalies.vue?vue&type=template&id=4307d5fe&scoped=true"
import script from "./Anomalies.vue?vue&type=script&lang=js"
export * from "./Anomalies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4307d5fe",
  null
  
)

export default component.exports